import { render, staticRenderFns } from "./EducationInfo.vue?vue&type=template&id=a6b4f890"
import script from "./EducationInfo.vue?vue&type=script&lang=js"
export * from "./EducationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports